<template lang="html">

  <section class="app-sidebar">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav" v-if="loginSuccess">
        <fragment v-if="isCcAdm">
          <li v-for="menuLv1 in getMenuList.submenuList" class="nav-item">
            <span  v-if="menuLv1.hasSubmenu" class="nav-link" v-b-toggle="menuLv1.linkTo + '-sub'" :id="menuLv1.linkTo">
              <span class="menu-title">{{menuLv1.description}}</span><i class="menu-arrow"></i>
            </span>                     
            <router-link v-else :id="menuLv1.linkTo" exact class="nav-link" :to="{ name: menuLv1.linkTo, query: { action: 'search', activeGroup: getActiveGroup(menuLv1.description) }}">{{menuLv1.description}}</router-link>
            <b-collapse :id="menuLv1.linkTo + '-sub'">
              <ul class="nav flex-column sub-menu">
                <li v-if="menuLv1.submenuList && menuLv1.submenuList.length" :parent="menuLv1.linkTo" v-for="submenu in menuLv1.submenuList" class="nav-item" @click="activeMenuElement($event)">
                  <router-link v-if="submenu.linkTo && submenu.linkTo.length" exact class="nav-link" :to="submenu.linkTo">{{submenu.description}}</router-link>
                  <router-link v-else exact class="nav-link" :to="{ name: menuLv1.linkTo, query: { action: 'search', activeGroup: submenu.description }}">{{submenu.description}}</router-link>
                </li>
              </ul>
            </b-collapse>
          </li>
        </fragment>
        <fragment v-if="isPriceConf">
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#market_model"><span class="menu-title">Market and Model</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#discount_and_visibility"><span class="menu-title">Discount and Visibility</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#online_taxes"><span class="menu-title">Online Taxes</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#prices_equipment"><span class="menu-title">Model Prices and Equipments</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#customer_programs"><span class="menu-title">Customer Programs</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#accessories"><span class="menu-title">Accessories</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/price_configurator#taxes"><span class="menu-title">Taxes</span></router-link></li>
        </fragment>
        <fragment v-if="isPackConf">
          <li class="nav-item"><router-link exact class="nav-link" to="/pack_configurator"><span class="menu-title">Packs management</span></router-link></li>
          <li class="nav-item"><router-link exact class="nav-link" to="/implicit_packs"><span class="menu-title">Implicit packs</span></router-link></li>
        </fragment>
        <fragment v-if="isSolModel || isSolCampaign || isSolDownpayment">
          <li class="nav-item"><b-nav-item href="#"  @click="$router.push('/sol_model/')">SOL Visibility</b-nav-item></li>
          <li class="nav-item"><b-nav-item href="#"  @click="$router.push('/sol_campaign/')">Discounts Campaigns</b-nav-item></li>
          <li class="nav-item"><b-nav-item href="#"  @click="$router.push('/sol_country/')">Country Configuration</b-nav-item></li>
          <li class="nav-item"><b-nav-item href="#"  @click="$router.push('/sol_downpayment/')">Sol Downpayment</b-nav-item></li>
        </fragment>
        <fragment v-if="isFinco">          
          <li class="nav-item"><b-nav-item href="#"  @click="$router.push('/sol_country/')">Country Configuration</b-nav-item></li>
        </fragment>
      </ul>
    </nav>
  </section>

</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'app-sidebar',
  computed: { 
    getMenu () {
      return this.getMenuList
    },
    ...mapGetters([
      'authHeader',
      'isCcAdm',
      'isPriceConf',
      'isPackConf',
      'isSolModel',
      'isSolCampaign',
      'isSolDownpayment',
      'getCurLanguage',
      'getMenuList',
      'getCurModel',
      'getSolServiceActive',
      'isFinco'
    ]),
    ...mapState([
      'loginSuccess'
    ])
  }, 
  methods: {
    getActiveGroup(description) {
      if (description === 'OPT Labels') {
        return 'OPT';
      }
      if (description === 'ACC Labels') {
        return 'ACC';
      }
      if (description === 'COLOR Labels') {
        return 'COLOR';
      }
      if (description === 'CUSTPRG Labels') {
        return 'CUSTPRG';
      }
      return description;
    },
    activeMenuElement(event){      
      var parent = event.target.parentElement.getAttribute('parent')
      var subs = document.querySelector('#' + parent + '-sub').querySelectorAll('[parent='+parent+']')
      for (var i = 0; i < subs.length; i++) {
        subs[i].classList.remove('active');
      }
      event.target.parentElement.classList.add('active');

    },

     ...mapActions([
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setMenuList',
      'setSolServiceActive'
    ]),
   loadFromSubMenu (el, menuLv1) {
    
     var url = this.getMenuURL(menuLv1)
     var params = this.getParams(el, menuLv1)
     var responseAction = this.getResponseAction (menuLv1);
     this.axios
      .get(url ,  {
        params: params,
        ...this.authHeader}
          )
          .then((response) => {
          responseAction(response.data)                   
          });
    },
    getParams (el, menuLv1) {
      var params = null;
      if (menuLv1.description.toLowerCase() === 'interface labels') {
        this.setCurLabelGroup(el.description)
        params = {modelName: this.getCurModel, language:this.getCurLanguage, labelGroup: el.description}
      }
      else if (menuLv1.description.toLowerCase() === 'opt labels') {
        this.setCurLabelGroup(el.description)
        params = {modelName: this.getCurModel,  optGroup: el.description}
      }

      return params;

    },    
    getMenuURL (menuLv1) {
      var url = null;
      if (menuLv1.description.toLowerCase() === 'interface labels') {
        url = '/ccb/auth/fe/interfaceLabel/findByGroup'
      }      
      else if (menuLv1.description.toLowerCase() === 'opt labels') {
        url = '/ccb/auth/fe/optGridLabel/findByOptGroupAndModelName'
      }

      return url;
    },    
    getResponseAction (menuLv1) {
      var responseAction = null;
      if (menuLv1.description.toLowerCase() === 'interface labels') {
        responseAction = this.setInterfaceLabels
      }      
      else if (menuLv1.description.toLowerCase() === 'opt labels') {
        responseAction = function (data) {
          console.log("RESPONSE: \n")
          console.log(data);
        } 
      }

      return responseAction;
    },
    checkSolServiceStatus() {
      this.axios
        .get('/ccb/auth/fe/consoleConfig/getValue/SOL_SERVICE_AVAILABLE', {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          this.setSolServiceActive(false)
          if(new String(response.data).toLowerCase() =='true')
            this.setSolServiceActive(true)
        });

    }

  },
  mounted(){
    this.checkSolServiceStatus()
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {

}
</style>
